// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".calender-component .v-btn--fab.v-size--default{width:40px;height:40px}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/mypage/components/CalendarComponent.vue"],"names":[],"mappings":"AAGC,gDACC,UAAA,CACA,WAAA","file":"CalendarComponent.vue","sourcesContent":["\n.calender-component {\n\n\t.v-btn--fab.v-size--default {\n\t\twidth: 40px;\n\t\theight: 40px;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
